import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import React, { useEffect } from 'react';
import {
  getResourceStatus,
  restartffmpeg,
  restartFirefox,
  restartEc2,
  getTokenForAdmin,
} from 'utils/apiCalls';
import PropTypes from 'prop-types';
import moment from 'moment';
import VideoWrapper from './VideoWrapper.js';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from 'react-router-dom';

const useRowStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  buttons: {
    margin: '1rem',
  },
  dangerButtons: {
    margin: '1rem',
    backgroundColor: theme.palette.danger || 'red',
  },
  helpRequests: {
    textAlign: 'left',
    maxHeight: '5rem',
    width: '20rem',
    overflowX: 'hidden',
    overflowY: 'auto',

    '& > *': {
      margin: '0.25rem 0',
      wordBreak: 'break-word',
    },
  },
}));

Row.propTypes = {
  row: PropTypes.object,
};

export default function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [jsonOpen, setjsonOpen] = React.useState(false);
  const [resource, setResource] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const classes = useRowStyles();
  const history = useHistory();
  useEffect(() => {
    const calls = async () => {
      setLoading(true);
      if (row.CurrentResourceId)
        setResource(await getResourceStatus(row.SessionId, row.CurrentResourceId));
      setLoading(false);
    };
    calls();
  }, [row.CurrentResourceId, row.SessionId]);

  const requests = row.HelpRequest;

  const joinSession = async (role, sessionId) => {
    const tokenData = await getTokenForAdmin(role, sessionId);
    // console.log('TOKENDATA', tokenData);
    if (tokenData) {
      // console.log('IN TOKENDATA');
      history.push(`/conference/?token=${tokenData.data}`);
    }
  };

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.Title}
        </TableCell>
        <TableCell align="right">{row.Status}</TableCell>
        <TableCell align="right">{row.SessionId}</TableCell>
        <TableCell align="right">{row.CurrentResourceId}</TableCell>
        <TableCell align="right">
          {!requests && 'None'}
          <div className={classes.helpRequests}>
            {requests &&
              requests
                .sort((a, b) => b.TimeStamp - a.TimeStamp)
                .map((request) => (
                  <div key={request.UserId + request.TimeStamp}>
                    <strong>{moment(request.TimeStamp).format('h:mm A')}</strong>
                    {`: ${request.Message}`}
                  </div>
                ))}
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {loading ? (
              <CircularProgress />
            ) : (
              <Box margin={1}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Resource Status</TableCell>
                      <TableCell>Media Live</TableCell>
                      <TableCell>IVS</TableCell>
                      <TableCell>EC2</TableCell>
                      <TableCell>Viewers</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableRow>
                    <TableCell>{resource?.resource?.Status}</TableCell>
                    <TableCell>{resource?.mediaLive?.State}</TableCell>
                    <TableCell>{resource?.ivs?.State}</TableCell>
                    <TableCell>
                      {resource?.ec2?.InstanceStatuses?.[0]?.InstanceState?.Name}
                    </TableCell>
                    <TableCell>{resource?.ivs?.Viewers}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={8}>
                      <Box style={{ display: 'flex', margin: '1rem' }}>
                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.buttons}
                            onClick={() => joinSession('attendee', row.SessionId)}
                          >
                            join audience
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.buttons}
                            onClick={() => joinSession('presenter', row.SessionId)}
                          >
                            join presenters
                          </Button>
                          {row.CurrentResourceId && (
                            <>
                              <Button
                                color="secondary"
                                className={classes.dangerButtons}
                                variant="contained"
                                onClick={() => restartffmpeg(resource?.resource?.Ec2Id)}
                              >
                                restart ffmpeg
                              </Button>
                              <Button
                                color="secondary"
                                className={classes.dangerButtons}
                                variant="contained"
                                onClick={() => restartFirefox(resource?.resource?.Ec2Id)}
                              >
                                restart firefox
                              </Button>
                              <Button
                                color="secondary"
                                className={classes.dangerButtons}
                                variant="contained"
                                onClick={() => restartEc2(row.SessionId, row.CurrentResourceId)}
                              >
                                restart server
                              </Button>
                            </>
                          )}
                        </Box>
                        <div>
                          {row.PlaybackUrl && <VideoWrapper playbackUrl={row.PlaybackUrl} />}
                        </div>
                        <div style={{ maxWidth: '600px', margin: '0 1rem' }}>
                          <Button onClick={() => setjsonOpen(!jsonOpen)}>JSON</Button>
                          <Collapse in={jsonOpen} timeout="auto" unmountOnExit>
                            <div style={{ maxHeight: '375px', overflow: 'auto' }}>
                              <pre>{JSON.stringify(row, null, 2)}</pre>
                            </div>
                          </Collapse>
                        </div>
                      </Box>
                    </TableCell>
                  </TableRow>
                </Table>
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
